import React, { useState } from 'react';

export default function SendgridTest() {
  const [to, setTo] = useState('');
  const [subject, setSubject] = useState('Glowytics SendGrid Test');
  const [html, setHtml] = useState('<strong>Hello from Glowytics</strong>');
  const [from, setFrom] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const send = async () => {
    try {
      setLoading(true);
      setResult(null);
      const brandId = typeof window !== 'undefined' ? localStorage.getItem('currentBrandId') : null;
      const headers = { 'Content-Type': 'application/json' };
      if (brandId) headers['X-Brand-ID'] = brandId;
      const base = (typeof window !== 'undefined' && window.location.hostname === 'localhost') ? '' : 'https://api.glowytics.com';
      const res = await fetch(`${base}/api/email/sendgrid-test`, {
        method: 'POST',
        credentials: 'include',
        headers,
        body: JSON.stringify({ to, subject, html, from: from || undefined })
      });
      const js = await res.json().catch(() => ({}));
      setResult(res.ok ? { ok: true, ...js } : { ok: false, ...js });
    } catch (e) {
      setResult({ ok: false, error: e.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto space-y-4">
      <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-4">
        <div className="text-lg font-semibold mb-2">SendGrid Test (Standalone)</div>
        <div className="grid grid-cols-1 gap-3">
          <input className="border rounded-lg px-3 py-2" placeholder="To (recipient email)" value={to} onChange={e => setTo(e.target.value)} />
          <input className="border rounded-lg px-3 py-2" placeholder="From (optional, must be verified)" value={from} onChange={e => setFrom(e.target.value)} />
          <input className="border rounded-lg px-3 py-2" placeholder="Subject" value={subject} onChange={e => setSubject(e.target.value)} />
          <textarea className="border rounded-lg px-3 py-2 h-40 font-mono" placeholder="<html>...</html>" value={html} onChange={e => setHtml(e.target.value)} />
          <button
            className="px-4 py-2 rounded-xl bg-indigo-600 text-white disabled:opacity-60"
            onClick={send}
            disabled={loading || !to}
          >
            {loading ? 'Sending…' : 'Send Test'}
          </button>
          {result && (
            <div className={`text-sm ${result.ok ? 'text-emerald-700' : 'text-rose-700'}`}>
              {result.ok ? `Sent. messageId=${result.messageId || 'n/a'}` : `Failed: ${result.error || 'Unknown error'}`}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}


